export default __webpack_public_path__ + "static/media/insta.5701e171.svg";